// Use these links
export const APPSTORE_LINK =
  'https://apps.apple.com/us/app/dineout-iceland/id1444956653?ign-itscg=30200&ign-itsct=apps_box';
export const PLAYSTORE_LINK =
  'https://play.google.com/store/apps/details?id=com.dineout.mobile&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1';
